import {hmapPathParamConfig, hmapPathParamRegex} from "../../modules/hmap/hmap.routes.js";

export const PayRunsRoutes = {
    "/pay-runs": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.clock-time.pay-runs",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["pay-runs"]
        },
        "views": {
            "clock-time-body": {
                component: "payRunsContainer"
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Pay Runs | Harri"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("../paysheet-payrun/paysheet-payrun.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("./pay-runs.module.js");
                }
            },
        ],
        "onEnter": ['usePayRunsListFactory', 'hUser', 'hmapService',
            async (usePayRunsListFactory, hUser, hmapService) => {
                const brand ={
                    id: hUser.isTopLevelContext() ? hmapService.getActiveBrand() : hUser.getActiveBrandIdWithAccess(),
                };
                await usePayRunsListFactory().hasManagePayRunsAccess(brand)
            },
        ],
    },
    "/pay-run-details?payRunTypeId&payRunId": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.clock-time.pay-run-details",
        "type": "frontend",
        "views": {
            "clock-time-body": {
                component: "payRunDetailsContainer"
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Pay Run Details | Harri"
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("../paysheet-payrun/paysheet-payrun.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("./pay-runs.module.js");
                }
            },
        ]
    },
    [`/pay-runs/${hmapPathParamRegex}`]: {
        "name": "appLayout.harriSH.access-portal.pay-runs",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Pay Runs"
            }
        ],
        "params": {
            ...hmapPathParamConfig
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["pay-runs", 'centralized-settings']
        },
        "component": "payRunsContainer",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("../paysheet-payrun/paysheet-payrun.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("./pay-runs.module.js");
                }
            },
        ]
    },
    [`/pay-run-details/${hmapPathParamRegex}?payRunTypeId&payRunId`]: {
        "name": "appLayout.harriSH.access-portal.pay-run-details",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["pay-runs", 'centralized-settings']
        },
        "component": "payRunDetailsContainer",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("../paysheet-payrun/paysheet-payrun.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("./pay-runs.module.js");
                }
            },
        ],
        "onEnter": ['usePayRunsListFactory', 'hUser', 'hmapService',
            async (usePayRunsListFactory, hUser, hmapService) => {
                const brand ={
                    id: hUser.isTopLevelContext() ? hmapService.getActiveBrand() : hUser.getActiveBrandIdWithAccess(),
                };
                await usePayRunsListFactory().hasManagePayRunsAccess(brand)
            },
        ],
    },
};